
// // // // // // // import React, { useState, useEffect, useRef } from "react";
// // // // // // // import axios from "axios";
// // // // // // // import { Html5QrcodeScanner } from "html5-qrcode";
// // // // // // // import CustomInputLogin from "../../../Components/CustomInput/CustomInput";
// // // // // // // import { Formik, Form } from "formik";
// // // // // // // // import { Form } from "react-router-dom";
// // // // // // // import { Box, Button, Grid, Grid2, Typography } from "@mui/material";
// // // // // // // import { toast, ToastContainer } from "react-toastify";
// // // // // // // import * as Yup from 'yup';
// // // // // // // // import { adminUrl } from "../../constants";
// // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // import { adminUrl } from "../../../constants";
// // // // // // // import OtpsSendModal from "../../../Components/OtpSendModal/OtpsSendModal";
// // // // // // // import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";
// // // // // // // import { useDispatch } from "react-redux";
// // // // // // // import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";


// // // // // // // const WithdrawForSacnQR = () => {
// // // // // // //     const [goldGrams, setGoldGrams] = useState("");
// // // // // // //     const [qrCode, setQrCode] = useState("");
// // // // // // //     const [message, setMessage] = useState("");
// // // // // // //     const [showScanner, setShowScanner] = useState(true);
// // // // // // //     const [otp, setOtp] = useState("");
// // // // // // //     const [showOtpInput, setShowOtpInput] = useState(false);
// // // // // // //     const [scannedQrCode, setScannedQrCode] = useState(""); // Store scanned QR code
// // // // // // //     const scannerRef = useRef(null);
// // // // // // //     const [isOtpSendModalOpen, setIsOtpSendModalOpen] = useState(false)
// // // // // // //     const handleOtpSendModalClose = () => {
// // // // // // //         setIsOtpSendModalOpen(false)
// // // // // // //     }


// // // // // // //     const [loading, setLoading] = useState(false);


// // // // // // //     console.log(loading, "loadinggggggggg")


// // // // // // //     const sessioncustomer_id = sessionStorage.getItem("sessioncustomer_id");


// // // // // // //     const initiateVerification = async (qr) => {
// // // // // // //         setLoading(true)
// // // // // // //         try {
// // // // // // //             const response = await axios.post(`${adminUrl}/verify-qr`, {
// // // // // // //                 qr_code: qr,
// // // // // // //             });
// // // // // // //             // setLoading(false)
// // // // // // //             setMessage(response.data.message);


// // // // // // //             console.log(response.data, "GoldWithdrawalGoldWithdrawal");
// // // // // // //             setIsOtpSendModalOpen(true)
// // // // // // //             setScannedQrCode(qr); // Store QR code for Step 2
// // // // // // //             setShowOtpInput(true); // Show OTP input after Step 1
// // // // // // //         } catch (error) {
// // // // // // //             setMessage(error.response?.data?.message || "Error initiating verification");
// // // // // // //         }
// // // // // // //         finally {
// // // // // // //             setLoading(false); // Ensure loading state is reset even if an error occurs
// // // // // // //         }
// // // // // // //     };

// // // // // // //     const completeVerification = async (otpCode) => {
// // // // // // //         try {
// // // // // // //             const response = await axios.post(`${adminUrl}/verify-qr`, {
// // // // // // //                 qr_code: scannedQrCode,
// // // // // // //                 otp: otpCode,
// // // // // // //             });

// // // // // // //             console.log(response.data, "GoldWithdrawalGoldWithdrawal");

// // // // // // //             setMessage(`Verification successful! Withdrawal Amount: ${response.data.gold_grams} grams`);
// // // // // // //             toast.success(`Verification successful! Withdrawal Amount: ${response.data.gold_grams} grams`);
// // // // // // //             handleOtpSendModalClose()

// // // // // // //             setShowOtpInput(false); // Hide OTP input after successful verification
// // // // // // //         } catch (error) {
// // // // // // //             setMessage(error.response?.data?.message || "Error verifying OTP");
// // // // // // //             toast.error(error.response?.data?.message)
// // // // // // //             // handleOtpSendModalClose()
// // // // // // //         }
// // // // // // //         // finally {
// // // // // // //         //     setLoading(false); // Ensure loading state is reset even if an error occurs
// // // // // // //         // }
// // // // // // //     };

// // // // // // //     useEffect(() => {
// // // // // // //         if (showScanner) {
// // // // // // //             scannerRef.current = new Html5QrcodeScanner("reader", {
// // // // // // //                 fps: 10,
// // // // // // //                 qrbox: 250,
// // // // // // //             });

// // // // // // //             scannerRef.current.render(
// // // // // // //                 (decodedText) => {
// // // // // // //                     setShowScanner(false);
// // // // // // //                     scannerRef.current.clear();
// // // // // // //                     initiateVerification(decodedText); // Call Step 1
// // // // // // //                 },
// // // // // // //                 (error) => console.error("QR Scan Error:", error)
// // // // // // //             );
// // // // // // //         }

// // // // // // //         return () => {
// // // // // // //             if (scannerRef.current) {
// // // // // // //                 scannerRef.current.clear();
// // // // // // //             }
// // // // // // //         };
// // // // // // //     }, [showScanner]);

// // // // // // //     const navigate = useNavigate()
// // // // // // //     const dispatch=useDispatch()

// // // // // // //     useEffect(() => {
// // // // // // //         dispatch(setHeaderName("Master"));
// // // // // // //         dispatch(setSubHeaderName("Withdraw Gold"));
// // // // // // //     }, []);


// // // // // // //     return (
// // // // // // //         <div style={{ padding: "20px", textAlign: "center" }}>

// // // // // // //             {loading && <FullPageLoader />}


// // // // // // //             <div className="login-container">
// // // // // // //                 <Grid container >
// // // // // // //                     <Grid
// // // // // // //                         item
// // // // // // //                         xs={12}
// // // // // // //                         md={12}
// // // // // // //                         sx={{
// // // // // // //                             display: "flex",
// // // // // // //                             alignItems: "center",
// // // // // // //                             justifyContent: "center",
// // // // // // //                             p: 4,
// // // // // // //                             // background: "#FFFFFF",
// // // // // // //                             width: "100%",
// // // // // // //                         }}
// // // // // // //                     >
// // // // // // //                         <Box
// // // // // // //                             sx={{
// // // // // // //                                 width: "100%",
// // // // // // //                                 maxWidth: 350,
// // // // // // //                                 py: 8,
// // // // // // //                                 px: 4,
// // // // // // //                                 display: "flex",
// // // // // // //                                 flexDirection: "column",
// // // // // // //                                 alignItems: "center",
// // // // // // //                                 justifyContent: "center",
// // // // // // //                                 boxShadow: "2px",
// // // // // // //                                 background: "white",
// // // // // // //                             }}
// // // // // // //                         >
// // // // // // //                             <Typography variant="h4" textAlign="center" sx={{ fontSize: "30px", fontWeight: "600", mb: 4 }}>
// // // // // // //                                 Scan QR
// // // // // // //                             </Typography>

// // // // // // //                             {showScanner && <div id="reader" style={{ width: "300px", margin: "auto" }}></div>}


// // // // // // //                             {/* Message Output */}
// // // // // // //                             {message &&
// // // // // // //                                 <>
// // // // // // //                                     <p style={{ marginTop: "10px", color: "green" }}>{message}
// // // // // // //                                     </p>
// // // // // // //                                     <Button
// // // // // // //                                         variant="contained"
// // // // // // //                                         // type="submit"

// // // // // // //                                         onClick={() => {
// // // // // // //                                             setMessage("")
// // // // // // //                                             setShowScanner(true)
// // // // // // //                                         }}
// // // // // // //                                         // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
// // // // // // //                                         sx={{
// // // // // // //                                             // backgroundColor: "#C38F51",
// // // // // // //                                             mt: 2,
// // // // // // //                                             textTransform: "none",
// // // // // // //                                             color: "white",
// // // // // // //                                             fontSize: "16px",
// // // // // // //                                             // padding: "0px 40px",
// // // // // // //                                             padding: { xs: "0px 20px", md: "0px 40px" },
// // // // // // //                                             width: "100%",
// // // // // // //                                             minHeight: "40px",
// // // // // // //                                             boxShadow: "none",

// // // // // // //                                             borderRadius: "23px",
// // // // // // //                                             color: "white",
// // // // // // //                                             background: "#C38F51 0% 0% no-repeat padding-box",
// // // // // // //                                             "&:hover": {
// // // // // // //                                                 backgroundColor: "#3B4056",
// // // // // // //                                             },
// // // // // // //                                         }}
// // // // // // //                                     >
// // // // // // //                                         Close
// // // // // // //                                     </Button>
// // // // // // //                                 </>
// // // // // // //                             }

// // // // // // //                         </Box>
// // // // // // //                     </Grid>

// // // // // // //                     <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />
// // // // // // //                 </Grid>
// // // // // // //             </div>


// // // // // // //             {/* <hr /> */}

// // // // // // //             <OtpsSendModal
// // // // // // //                 open={isOtpSendModalOpen}
// // // // // // //                 onClose={handleOtpSendModalClose}
// // // // // // //                 completeVerification={completeVerification}
// // // // // // //             />
// // // // // // //         </div>
// // // // // // //     );
// // // // // // // };

// // // // // // // export default WithdrawForSacnQR;




// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import jsQR from "jsqr";  // Import jsQR
// import { Box, Button, Grid, Typography } from "@mui/material";
// import { toast, ToastContainer } from "react-toastify";
// import { adminUrl } from "../../../constants";
// import OtpsSendModal from "../../../Components/OtpSendModal/OtpsSendModal";
// import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";
// import { useDispatch } from "react-redux";
// import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";

// const WithdrawForSacnQR = () => {
//     const [loading, setLoading] = useState(false);
//     const [message, setMessage] = useState("");
//     const [showScanner, setShowScanner] = useState(true);
//     const [scannedQrCode, setScannedQrCode] = useState(""); 
//     const [isOtpSendModalOpen, setIsOtpSendModalOpen] = useState(false);

//     const videoRef = useRef(null);
//     const canvasRef = useRef(null);
//     const streamRef = useRef(null);
//     const scanIntervalRef = useRef(null);

//     const dispatch = useDispatch();

//     useEffect(() => {
//         dispatch(setHeaderName("Master"));
//         dispatch(setSubHeaderName("Withdraw Gold"));
//     }, []);

//     const handleOtpSendModalClose = () => {
//         setIsOtpSendModalOpen(false);
//     };

//     // Function to start the camera and scan for QR codes
//     const startScanner = async () => {
//         try {
//             const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
//             videoRef.current.srcObject = stream;
//             streamRef.current = stream;

//             scanIntervalRef.current = setInterval(() => {
//                 scanQRCode();
//             }, 500);
//         } catch (error) {
//             console.error("Error accessing camera:", error);
//             setMessage("Camera access denied.");
//         }
//     };

//     // Function to scan QR code from video feed
//     const scanQRCode = () => {
//         if (!videoRef.current || !canvasRef.current) return;

//         const video = videoRef.current;
//         const canvas = canvasRef.current;
//         const context = canvas.getContext("2d");

//         canvas.width = video.videoWidth;
//         canvas.height = video.videoHeight;
//         context.drawImage(video, 0, 0, canvas.width, canvas.height);

//         const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
//         const code = jsQR(imageData.data, imageData.width, imageData.height);

//         if (code) {
//             stopScanner();
//             initiateVerification(code.data);
//         }
//     };

//     // Function to stop the scanner
//     const stopScanner = () => {
//         if (scanIntervalRef.current) {
//             clearInterval(scanIntervalRef.current);
//         }
//         if (streamRef.current) {
//             streamRef.current.getTracks().forEach(track => track.stop());
//         }
//         setShowScanner(false);
//     };

//     // Function to verify QR code
//     const initiateVerification = async (qr) => {
//         setLoading(true);
//         try {
//             const response = await axios.post(`${adminUrl}/verify-qr`, { qr_code: qr });
//             setMessage(response.data.message);
//             setIsOtpSendModalOpen(true);
//             setScannedQrCode(qr);
//         } catch (error) {
//             setMessage(error.response?.data?.message || "Error initiating verification");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const completeVerification = async (otpCode) => {
//         try {
//             const response = await axios.post(`${adminUrl}/verify-qr`, {
//                 qr_code: scannedQrCode,
//                 otp: otpCode,
//             });

//             toast.success(`Verification successful! Withdrawal Amount: ${response.data.gold_grams} grams`);
//             handleOtpSendModalClose();
//         } catch (error) {
//             toast.error(error.response?.data?.message || "Error verifying OTP");
//         }
//     };

//     return (
//         <div style={{ padding: "20px", textAlign: "center" }}>
//             {loading && <FullPageLoader />}
//             <div className="login-container">
//                 <Grid container>
//                     <Grid
//                         item
//                         xs={12}
//                         md={12}
//                         sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             p: 4,
//                             width: "100%",
//                         }}
//                     >
//                         <Box
//                             sx={{
//                                 width: "100%",
//                                 maxWidth: 350,
//                                 py: 8,
//                                 px: 4,
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 boxShadow: "2px",
//                                 background: "white",
//                             }}
//                         >
//                             <Typography variant="h4" textAlign="center" sx={{ fontSize: "30px", fontWeight: "600", mb: 4 }}>
//                                 Scan QR
//                             </Typography>

//                             {showScanner && (
//                                 <>
//                                     <video ref={videoRef} autoPlay style={{ width: "100%", maxWidth: "300px" }}></video>
//                                     <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
//                                     <Button
//                                         variant="contained"
//                                         sx={{
//                                             mt: 2,
//                                             textTransform: "none",
//                                             color: "white",
//                                             fontSize: "16px",
//                                             width: "100%",
//                                             minHeight: "40px",
//                                             borderRadius: "23px",
//                                             background: "#C38F51",
//                                             "&:hover": { backgroundColor: "#3B4056" },
//                                         }}
//                                         onClick={startScanner}
//                                     >
//                                         Start Scanning
//                                     </Button>
//                                 </>
//                             )}

//                             {message && (
//                                 <>
//                                     <Typography sx={{ mt: 2, color: "green" }}>{message}</Typography>
//                                     <Button
//                                         variant="contained"
//                                         sx={{
//                                             mt: 2,
//                                             textTransform: "none",
//                                             color: "white",
//                                             fontSize: "16px",
//                                             width: "100%",
//                                             minHeight: "40px",
//                                             borderRadius: "23px",
//                                             background: "#C38F51",
//                                             "&:hover": { backgroundColor: "#3B4056" },
//                                         }}
//                                         onClick={() => {
//                                             setMessage("");
//                                             setShowScanner(true);
//                                             startScanner();
//                                         }}
//                                     >
//                                         Scan Again
//                                     </Button>
//                                 </>
//                             )}
//                         </Box>
//                     </Grid>
//                     <ToastContainer position="top-right" autoClose={1500} hideProgressBar theme="dark" />
//                 </Grid>
//             </div>

//             <OtpsSendModal open={isOtpSendModalOpen} onClose={handleOtpSendModalClose} completeVerification={completeVerification} />
//         </div>
//     );
// };

// export default WithdrawForSacnQR;


// // // // // import React, { useState, useEffect, useRef } from "react";
// // // // // import axios from "axios";
// // // // // import jsQR from "jsqr";
// // // // // import { Box, Button, Grid, Typography } from "@mui/material";
// // // // // import { toast, ToastContainer } from "react-toastify";
// // // // // import { adminUrl } from "../../../constants";
// // // // // import OtpsSendModal from "../../../Components/OtpSendModal/OtpsSendModal";
// // // // // import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";
// // // // // import { useDispatch } from "react-redux";
// // // // // import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";

// // // // // const WithdrawForScanQR = () => {
// // // // //     const [loading, setLoading] = useState(false);
// // // // //     const [message, setMessage] = useState("");
// // // // //     const [showScanner, setShowScanner] = useState(true);
// // // // //     const [scannedQrCode, setScannedQrCode] = useState("");
// // // // //     const [isOtpSendModalOpen, setIsOtpSendModalOpen] = useState(false);

// // // // //     const videoRef = useRef(null);
// // // // //     const canvasRef = useRef(null);
// // // // //     const streamRef = useRef(null);
// // // // //     const scanIntervalRef = useRef(null);
// // // // //     const dispatch = useDispatch();

// // // // //     useEffect(() => {
// // // // //         dispatch(setHeaderName("Master"));
// // // // //         dispatch(setSubHeaderName("Withdraw Gold"));
// // // // //     }, []);

// // // // //     const handleOtpSendModalClose = () => {
// // // // //         setIsOtpSendModalOpen(false);
// // // // //     };

// // // // //     // Function to start the live scanner
// // // // //     const startScanner = async () => {
// // // // //         try {
// // // // //             const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
// // // // //             videoRef.current.srcObject = stream;
// // // // //             streamRef.current = stream;
// // // // //             scanIntervalRef.current = setInterval(() => {
// // // // //                 scanQRCode();
// // // // //             }, 500);
// // // // //         } catch (error) {
// // // // //             console.error("Error accessing camera:", error);
// // // // //             setMessage("Camera access denied.");
// // // // //         }
// // // // //     };

// // // // //     // Function to scan QR code from video feed
// // // // //     const scanQRCode = () => {
// // // // //         if (!videoRef.current || !canvasRef.current) return;
// // // // //         const video = videoRef.current;
// // // // //         const canvas = canvasRef.current;
// // // // //         const context = canvas.getContext("2d");

// // // // //         canvas.width = video.videoWidth;
// // // // //         canvas.height = video.videoHeight;
// // // // //         context.drawImage(video, 0, 0, canvas.width, canvas.height);

// // // // //         const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// // // // //         const code = jsQR(imageData.data, imageData.width, imageData.height);

// // // // //         if (code) {
// // // // //             stopScanner();
// // // // //             initiateVerification(code.data);
// // // // //         }
// // // // //     };

// // // // //     // Function to stop the scanner
// // // // //     const stopScanner = () => {
// // // // //         if (scanIntervalRef.current) clearInterval(scanIntervalRef.current);
// // // // //         if (streamRef.current) streamRef.current.getTracks().forEach(track => track.stop());
// // // // //         setShowScanner(false);
// // // // //     };

// // // // //     // Function to handle QR verification
// // // // //     const initiateVerification = async (qr) => {
// // // // //         setLoading(true);
// // // // //         try {
// // // // //             const response = await axios.post(`${adminUrl}/verify-qr`, { qr_code: qr });
// // // // //             setMessage(response.data.message);
// // // // //             setIsOtpSendModalOpen(true);
// // // // //             setScannedQrCode(qr);
// // // // //         } catch (error) {
// // // // //             setMessage(error.response?.data?.message || "Error initiating verification");
// // // // //         } finally {
// // // // //             setLoading(false);
// // // // //         }
// // // // //     };

// // // // //     // Function to complete verification with OTP
// // // // //     const completeVerification = async (otpCode) => {
// // // // //         try {
// // // // //             const response = await axios.post(`${adminUrl}/verify-qr`, {
// // // // //                 qr_code: scannedQrCode,
// // // // //                 otp: otpCode,
// // // // //             });

// // // // //             toast.success(`Verification successful! Withdrawal Amount: ${response.data.gold_grams} grams`);
// // // // //             handleOtpSendModalClose();
// // // // //         } catch (error) {
// // // // //             toast.error(error.response?.data?.message || "Error verifying OTP");
// // // // //         }
// // // // //     };

// // // // //     // Function to handle file upload and process QR code
// // // // //     const handleFileUpload = (event) => {
// // // // //         const file = event.target.files[0];
// // // // //         if (file) {
// // // // //             const reader = new FileReader();
// // // // //             reader.onload = (e) => {
// // // // //                 const img = new Image();
// // // // //                 img.src = e.target.result;
// // // // //                 img.onload = () => {
// // // // //                     const canvas = document.createElement("canvas");
// // // // //                     const context = canvas.getContext("2d");

// // // // //                     canvas.width = img.width;
// // // // //                     canvas.height = img.height;
// // // // //                     context.drawImage(img, 0, 0, canvas.width, canvas.height);

// // // // //                     const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// // // // //                     const code = jsQR(imageData.data, imageData.width, imageData.height);

// // // // //                     if (code) {
// // // // //                         initiateVerification(code.data);
// // // // //                     } else {
// // // // //                         toast.error("No QR code detected. Please try again.");
// // // // //                     }
// // // // //                 };
// // // // //             };
// // // // //             reader.readAsDataURL(file);
// // // // //         }
// // // // //     };

// // // // //     return (
// // // // //         <div style={{ padding: "20px", textAlign: "center" }}>
// // // // //             {loading && <FullPageLoader />}
// // // // //             <div className="login-container">
// // // // //                 <Grid container>
// // // // //                     <Grid
// // // // //                         item
// // // // //                         xs={12}
// // // // //                         md={12}
// // // // //                         sx={{
// // // // //                             display: "flex",
// // // // //                             alignItems: "center",
// // // // //                             justifyContent: "center",
// // // // //                             p: 4,
// // // // //                             width: "100%",
// // // // //                         }}
// // // // //                     >
// // // // //                         <Box
// // // // //                             sx={{
// // // // //                                 width: "100%",
// // // // //                                 maxWidth: 350,
// // // // //                                 py: 8,
// // // // //                                 px: 4,
// // // // //                                 display: "flex",
// // // // //                                 flexDirection: "column",
// // // // //                                 alignItems: "center",
// // // // //                                 justifyContent: "center",
// // // // //                                 boxShadow: "2px",
// // // // //                                 background: "white",
// // // // //                             }}
// // // // //                         >
// // // // //                             <Typography variant="h4" textAlign="center" sx={{ fontSize: "30px", fontWeight: "600", mb: 4 }}>
// // // // //                                 Scan or Upload QR Code
// // // // //                             </Typography>

// // // // //                             {showScanner && (
// // // // //                                 <>
// // // // //                                     <video ref={videoRef} autoPlay style={{ width: "100%", maxWidth: "300px" }}></video>
// // // // //                                     <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
// // // // //                                     <Button
// // // // //                                         variant="contained"
// // // // //                                         sx={{
// // // // //                                             mt: 2,
// // // // //                                             textTransform: "none",
// // // // //                                             color: "white",
// // // // //                                             fontSize: "16px",
// // // // //                                             width: "100%",
// // // // //                                             minHeight: "40px",
// // // // //                                             borderRadius: "23px",
// // // // //                                             background: "#C38F51",
// // // // //                                             "&:hover": { backgroundColor: "#3B4056" },
// // // // //                                         }}
// // // // //                                         onClick={startScanner}
// // // // //                                     >
// // // // //                                         Start Scanning
// // // // //                                     </Button>
// // // // //                                 </>
// // // // //                             )}

// // // // //                             {/* File Upload Button */}
// // // // //                             <input
// // // // //                                 type="file"
// // // // //                                 accept="image/*"
// // // // //                                 onChange={handleFileUpload}
// // // // //                                 style={{ display: "none" }}
// // // // //                                 id="upload-file"
// // // // //                             />
// // // // //                             <label htmlFor="upload-file">
// // // // //                                 <Button
// // // // //                                     variant="contained"
// // // // //                                     component="span"
// // // // //                                     sx={{
// // // // //                                         mt: 2,
// // // // //                                         textTransform: "none",
// // // // //                                         color: "white",
// // // // //                                         fontSize: "16px",
// // // // //                                         width: "100%",
// // // // //                                         minHeight: "40px",
// // // // //                                         borderRadius: "23px",
// // // // //                                         background: "#C38F51",
// // // // //                                         "&:hover": { backgroundColor: "#3B4056" },
// // // // //                                     }}
// // // // //                                 >
// // // // //                                     Upload QR Code
// // // // //                                 </Button>
// // // // //                             </label>

// // // // //                             {message && <Typography sx={{ mt: 2, color: "green" }}>{message}</Typography>}
// // // // //                         </Box>
// // // // //                     </Grid>
// // // // //                     <ToastContainer position="top-right" autoClose={1500} hideProgressBar theme="dark" />
// // // // //                 </Grid>
// // // // //             </div>

// // // // //             <OtpsSendModal open={isOtpSendModalOpen} onClose={handleOtpSendModalClose} completeVerification={completeVerification} />
// // // // //         </div>
// // // // //     );
// // // // // };

// // // // // export default WithdrawForScanQR;


// // // // import React, { useState, useEffect, useRef } from "react";
// // // // import axios from "axios";
// // // // import jsQR from "jsqr";
// // // // import { Box, Button, Grid, Typography, IconButton } from "@mui/material";
// // // // import { ArrowBack, QrCodeScanner } from "@mui/icons-material";
// // // // import { toast, ToastContainer } from "react-toastify";
// // // // import { adminUrl } from "../../../constants";
// // // // import OtpsSendModal from "../../../Components/OtpSendModal/OtpsSendModal";
// // // // import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";
// // // // import { useDispatch } from "react-redux";
// // // // import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";
// // // // import { useNavigate } from "react-router-dom";

// // // // const WithdrawForScanQR = () => {
// // // //     const [loading, setLoading] = useState(false);
// // // //     const [message, setMessage] = useState("");
// // // //     const [showScanner, setShowScanner] = useState(true);
// // // //     const [scannedQrCode, setScannedQrCode] = useState("");
// // // //     const [isOtpSendModalOpen, setIsOtpSendModalOpen] = useState(false);
// // // //     const [qrScanned, setQrScanned] = useState(false);
// // // //     const [initialView, setInitialView] = useState(true);

// // // //     const videoRef = useRef(null);
// // // //     const canvasRef = useRef(null);
// // // //     const streamRef = useRef(null);
// // // //     const scanIntervalRef = useRef(null);
// // // //     const dispatch = useDispatch();
// // // //     const navigate = useNavigate();

// // // //     useEffect(() => {
// // // //         dispatch(setHeaderName("Master"));
// // // //         dispatch(setSubHeaderName("Withdraw Gold"));
// // // //     }, []);

// // // //     const handleOtpSendModalClose = () => {
// // // //         setIsOtpSendModalOpen(false);
// // // //     };

// // // //     const startScanner = async () => {
// // // //         setShowScanner(true);
// // // //         setInitialView(false);

// // // //         try {
// // // //             const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
// // // //             videoRef.current.srcObject = stream;
// // // //             streamRef.current = stream;
// // // //             scanIntervalRef.current = setInterval(scanQRCode, 500);
// // // //         } catch (error) {
// // // //             setMessage("Camera access denied.");
// // // //         }
// // // //     };

// // // //     const scanQRCode = () => {
// // // //         if (!videoRef.current || !canvasRef.current) return;
// // // //         const video = videoRef.current;
// // // //         const canvas = canvasRef.current;
// // // //         const context = canvas.getContext("2d");

// // // //         canvas.width = video.videoWidth;
// // // //         canvas.height = video.videoHeight;
// // // //         context.drawImage(video, 0, 0, canvas.width, canvas.height);

// // // //         const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// // // //         const code = jsQR(imageData.data, imageData.width, imageData.height);

// // // //         if (code) {
// // // //             stopScanner();
// // // //             initiateVerification(code.data);
// // // //         }
// // // //     };

// // // //     const stopScanner = () => {
// // // //         if (scanIntervalRef.current) clearInterval(scanIntervalRef.current);
// // // //         if (streamRef.current) streamRef.current.getTracks().forEach(track => track.stop());
// // // //         setShowScanner(false);
// // // //     };

// // // //     const initiateVerification = async (qr) => {
// // // //         setLoading(true);
// // // //         try {
// // // //             const response = await axios.post(`${adminUrl}/verify-qr`, { qr_code: qr });
// // // //             setMessage(response.data.message);
// // // //             setIsOtpSendModalOpen(true);
// // // //             setScannedQrCode(qr);
// // // //             setQrScanned(true);
// // // //         } catch (error) {
// // // //             setMessage(error.response?.data?.message || "Error initiating verification");
// // // //         } finally {
// // // //             setLoading(false);
// // // //         }
// // // //     };

// // // //     const handleFileUpload = (event) => {
// // // //     setInitialView(false);
// // // //         const file = event.target.files[0];
// // // //         if (file) {
// // // //             const reader = new FileReader();
// // // //             reader.onload = (e) => {
// // // //                 const img = new Image();
// // // //                 img.src = e.target.result;
// // // //                 img.onload = () => {
// // // //                     const canvas = document.createElement("canvas");
// // // //                     const context = canvas.getContext("2d");
// // // //                     canvas.width = img.width;
// // // //                     canvas.height = img.height;
// // // //                     context.drawImage(img, 0, 0, canvas.width, canvas.height);
// // // //                     const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// // // //                     const code = jsQR(imageData.data, imageData.width, imageData.height);
// // // //                     if (code) {
// // // //                         initiateVerification(code.data);
// // // //                     } else {
// // // //                         toast.error("No QR code detected. Please try again.");
// // // //                     }
// // // //                 };
// // // //             };
// // // //             reader.readAsDataURL(file);
// // // //         }
// // // //     };

// // // //     return (
// // // //         <div style={{ padding: "20px", textAlign: "center" }}>
// // // //             {loading && <FullPageLoader />}
// // // //             <Box sx={{ p: 4, boxShadow: 2, background: "white", borderRadius: 2, position: "relative" }}>
// // // //                 <IconButton
// // // //                     onClick={() => {
// // // //                         setInitialView(true);
// // // //                         setQrScanned(false);
// // // //                         setShowScanner(true);
// // // //                         setMessage("");
// // // //                         stopScanner();
// // // //                     }}
// // // //                     sx={{ position: "absolute", top: 20, left: 20 }}
// // // //                 >
// // // //                     <ArrowBack />
// // // //                 </IconButton>

// // // //                 <Typography variant="h4" sx={{ fontSize: "24px", fontWeight: "600", mb: 2 }}>
// // // //                     {qrScanned ? "QR Code Scanned!" : "Scan or Upload QR Code"}
// // // //                 </Typography>

// // // //                 {initialView ? (
// // // //                     <Box sx={{ display: "flex", justifyContent: "center" }}>
// // // //                         <QrCodeScanner sx={{ fontSize: 80, color: "#C38F51", mb: 2 }} />
// // // //                     </Box>
// // // //                 ) : qrScanned ? (
// // // //                     <Typography sx={{ mt: 2, color: "green", fontSize: "18px", fontWeight: "bold" }}>
// // // //                         {message}
// // // //                     </Typography>
// // // //                 ) : (
// // // //                     <>
// // // //                         {showScanner && <video ref={videoRef} autoPlay style={{ width: "100%", maxWidth: "300px" }}></video>}
// // // //                         <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
// // // //                         <Button variant="contained" onClick={startScanner} sx={{ mt: 2, width: "100%" }}>
// // // //                             Start Scanning
// // // //                         </Button>
// // // //                         <input type="file" accept="image/*" onChange={handleFileUpload} id="upload-file" style={{ display: "none" }} />
// // // //                         <label htmlFor="upload-file">
// // // //                             <Button variant="contained" component="span" sx={{ mt: 2, width: "100%" }}>
// // // //                                 Upload QR Code
// // // //                             </Button>
// // // //                         </label>
// // // //                     </>
// // // //                 )}
// // // //             </Box>
// // // //             <ToastContainer position="top-right" autoClose={1500} hideProgressBar theme="dark" />
// // // //             <OtpsSendModal open={isOtpSendModalOpen} onClose={handleOtpSendModalClose} />
// // // //         </div>
// // // //     );
// // // // };

// // // // export default WithdrawForScanQR;


// // // import React, { useState, useEffect, useRef } from "react";
// // // import axios from "axios";
// // // import jsQR from "jsqr";
// // // import { Box, Button, Typography } from "@mui/material";
// // // import { QrCodeScanner } from "@mui/icons-material";
// // // import { toast, ToastContainer } from "react-toastify";
// // // import { adminUrl } from "../../../constants";
// // // import OtpsSendModal from "../../../Components/OtpSendModal/OtpsSendModal";
// // // import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";
// // // import { useDispatch } from "react-redux";
// // // import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";

// // // const WithdrawForScanQR = () => {
// // //     const [loading, setLoading] = useState(false);
// // //     const [message, setMessage] = useState("");
// // //     const [showScanner, setShowScanner] = useState(true);
// // //     const [scannedQrCode, setScannedQrCode] = useState("");
// // //     const [isOtpSendModalOpen, setIsOtpSendModalOpen] = useState(false);
// // //     const [qrScanned, setQrScanned] = useState(false);
// // //     const [initialView, setInitialView] = useState(true);

// // //     const videoRef = useRef(null);
// // //     const canvasRef = useRef(null);
// // //     const streamRef = useRef(null);
// // //     const scanIntervalRef = useRef(null);
// // //     const dispatch = useDispatch();

// // //     useEffect(() => {
// // //         dispatch(setHeaderName("Master"));
// // //         dispatch(setSubHeaderName("Withdraw Gold"));
// // //     }, [dispatch]);

// // //     const handleOtpSendModalClose = () => {
// // //         setIsOtpSendModalOpen(false);
// // //     };

// // //     const startScanner = async () => {
// // //         setShowScanner(true);
// // //         setInitialView(false);

// // //         try {
// // //             const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
// // //             videoRef.current.srcObject = stream;
// // //             streamRef.current = stream;
// // //             scanIntervalRef.current = setInterval(scanQRCode, 500);
// // //         } catch (error) {
// // //             setMessage("Camera access denied.");
// // //         }
// // //     };

// // //     const scanQRCode = () => {
// // //         if (!videoRef.current || !canvasRef.current) return;
// // //         const video = videoRef.current;
// // //         const canvas = canvasRef.current;
// // //         const context = canvas.getContext("2d");

// // //         canvas.width = video.videoWidth;
// // //         canvas.height = video.videoHeight;
// // //         context.drawImage(video, 0, 0, canvas.width, canvas.height);

// // //         const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// // //         const code = jsQR(imageData.data, imageData.width, imageData.height);

// // //         if (code) {
// // //             stopScanner();
// // //             initiateVerification(code.data);
// // //         }
// // //     };

// // //     const stopScanner = () => {
// // //         if (scanIntervalRef.current) clearInterval(scanIntervalRef.current);
// // //         if (streamRef.current) streamRef.current.getTracks().forEach(track => track.stop());
// // //         setShowScanner(false);
// // //     };

// // //     // const initiateVerification = async (qr) => {
// // //     //     setLoading(true);
// // //     //     try {
// // //     //         const response = await axios.post(`${adminUrl}/verify-qr`, { qr_code: qr });
// // //     //         setMessage(response.data.message);
// // //     //         setIsOtpSendModalOpen(true);
// // //     //         setScannedQrCode(qr);
// // //     //         setQrScanned(true);
// // //     //     } catch (error) {
// // //     //         setMessage(error.response?.data?.message || "Error initiating verification");
// // //     //     } finally {
// // //     //         setLoading(false);
// // //     //     }
// // //     // };

// // //     const initiateVerification = async (qr) => {
// // //     setLoading(true);
// // //     try {
// // //         const response = await axios.post(`${adminUrl}/verify-qr`, { qr_code: qr });

// // //         // Set scanned QR code first
// // //         setScannedQrCode(qr);

// // //         // Ensure `qrScanned` is updated before setting the message
// // //         setQrScanned(true);  

// // //         setTimeout(() => {
// // //             setMessage(response.data.message);
// // //         }, 100); // Small delay to ensure re-render

// // //         setIsOtpSendModalOpen(true);
// // //     } catch (error) {
// // //         setMessage(error.response?.data?.message || "Error initiating verification");
// // //     } finally {
// // //         setLoading(false);
// // //     }
// // // };


// // //     const handleFileUpload = (event) => {
// // //         setInitialView(false);
// // //         const file = event.target.files[0];
// // //         if (file) {
// // //             const reader = new FileReader();
// // //             reader.onload = (e) => {
// // //                 const img = new Image();
// // //                 img.src = e.target.result;
// // //                 img.onload = () => {
// // //                     const canvas = document.createElement("canvas");
// // //                     const context = canvas.getContext("2d");
// // //                     canvas.width = img.width;
// // //                     canvas.height = img.height;
// // //                     context.drawImage(img, 0, 0, canvas.width, canvas.height);
// // //                     const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// // //                     const code = jsQR(imageData.data, imageData.width, imageData.height);
// // //                     if (code) {
// // //                         initiateVerification(code.data);
// // //                     } else {
// // //                         toast.error("No QR code detected. Please try again.");
// // //                     }
// // //                 };
// // //             };
// // //             reader.readAsDataURL(file);
// // //         }
// // //     };

// // //     return (
// // //         <div style={{ padding: "20px", textAlign: "center" }}>
// // //             {loading && <FullPageLoader />}
// // //             <Box sx={{ p: 4, boxShadow: 2, background: "white", borderRadius: 2 }}>

// // //                 <Typography variant="h4" sx={{ fontSize: "24px", fontWeight: "600", mb: 2 }}>
// // //                     {qrScanned ? "QR Code Scanned!" : "Scan or Upload QR Code"}
// // //                 </Typography>

// // //                 {qrScanned ? (
// // //                     <>
// // //                         <Typography sx={{ mt: 2, color: "green", fontSize: "18px", fontWeight: "bold" }}>
// // //                             {message}
// // //                         </Typography>
// // //                         <Button
// // //                             variant="contained"
// // //                             onClick={() => {
// // //                                 setInitialView(true);
// // //                                 setQrScanned(false);
// // //                                 setShowScanner(true);
// // //                                 setMessage("");
// // //                                 stopScanner();
// // //                             }}
// // //                             sx={{ mt: 2, width: "100%" }}
// // //                         >
// // //                             Back
// // //                         </Button>
// // //                     </>
// // //                 ) : (
// // //                     <>
// // //                         {initialView ? (
// // //                             <Box sx={{ display: "flex", justifyContent: "center" }}>
// // //                                 <QrCodeScanner sx={{ fontSize: 80, color: "#C38F51", mb: 2 }} />
// // //                             </Box>
// // //                         ) : showScanner && (
// // //                             <video ref={videoRef} autoPlay style={{ width: "100%", maxWidth: "300px" }}></video>
// // //                         )}

// // //                         <canvas ref={canvasRef} style={{ display: "none" }}></canvas>

// // //                         {!qrScanned && (
// // //                             <>
// // //                                 <Button variant="contained" onClick={startScanner} sx={{ mt: 2, width: "100%" }}>
// // //                                     Start Scanning
// // //                                 </Button>
// // //                                 <input type="file" accept="image/*" onChange={handleFileUpload} id="upload-file" style={{ display: "none" }} />
// // //                                 <label htmlFor="upload-file">
// // //                                     <Button variant="contained" component="span" sx={{ mt: 2, width: "100%" }}>
// // //                                         Upload QR Code
// // //                                     </Button>
// // //                                 </label>
// // //                             </>
// // //                         )}
// // //                     </>
// // //                 )}
// // //             </Box>
// // //             <ToastContainer position="top-right" autoClose={1500} hideProgressBar theme="dark" />
// // //             <OtpsSendModal open={isOtpSendModalOpen} onClose={handleOtpSendModalClose} />
// // //         </div>
// // //     );
// // // };

// // // export default WithdrawForScanQR;





// // import React, { useState, useEffect, useRef } from "react";
// // import axios from "axios";
// // import jsQR from "jsqr";
// // import { Box, Button, Grid, Typography } from "@mui/material";
// // import { toast, ToastContainer } from "react-toastify";
// // import { adminUrl } from "../../../constants";
// // import OtpsSendModal from "../../../Components/OtpSendModal/OtpsSendModal";
// // import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";
// // import { useDispatch } from "react-redux";
// // import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";
// // import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// // import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

// // const WithdrawForScanQR = () => {
// //     const [loading, setLoading] = useState(false);
// //     const [message, setMessage] = useState("");
// //     const [showScanner, setShowScanner] = useState(true);
// //     const [showButtons, setShowButtons] = useState(true);
// //     const [scannedQrCode, setScannedQrCode] = useState("");
// //     const [isOtpSendModalOpen, setIsOtpSendModalOpen] = useState(false);

// //     const videoRef = useRef(null);
// //     const canvasRef = useRef(null);
// //     const streamRef = useRef(null);
// //     const scanIntervalRef = useRef(null);

// //     const dispatch = useDispatch();

// //     useEffect(() => {
// //         dispatch(setHeaderName("Master"));
// //         dispatch(setSubHeaderName("Withdraw Gold"));
// //     }, []);

// //     const handleOtpSendModalClose = () => {
// //         setIsOtpSendModalOpen(false);
// //     };

// //     // const startScanner = async () => {
// //     //     try {
// //     //         setShowButtons(false);
// //     //         const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
// //     //         videoRef.current.srcObject = stream;
// //     //         streamRef.current = stream;

// //     //         scanIntervalRef.current = setInterval(() => {
// //     //             scanQRCode();
// //     //         }, 500);
// //     //     } catch (error) {
// //     //         console.error("Error accessing camera:", error);
// //     //         setMessage("Camera access denied.");
// //     //     }
// //     // };




// //     // const startScanner = async () => {
// //     //     try {
// //     //         const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
// //     //         videoRef.current.srcObject = stream;
// //     //         streamRef.current = stream;
// //     //         scanIntervalRef.current = setInterval(() => {
// //     //             scanQRCode();
// //     //         }, 500);
// //     //     } catch (error) {
// //     //         console.error("Error accessing camera:", error);
// //     //         setMessage("Camera access denied.");
// //     //     }
// //     // };


// //     const startScanner = async () => {
// //         try {
// //             const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
// //             videoRef.current.srcObject = stream;
// //             streamRef.current = stream;

// //             videoRef.current.onloadedmetadata = () => {
// //                 videoRef.current.play(); // Start the video playback
// //             };

// //             scanIntervalRef.current = setInterval(scanQRCode, 500);
// //         } catch (error) {
// //             console.error("Error accessing camera:", error);
// //             setMessage("Camera access denied.");
// //         }
// //     };

// //     // const scanQRCode = () => {
// //     //     if (!videoRef.current || !canvasRef.current) return;

// //     //     const video = videoRef.current;
// //     //     const canvas = canvasRef.current;
// //     //     const context = canvas.getContext("2d");

// //     //     canvas.width = video.videoWidth;
// //     //     canvas.height = video.videoHeight;
// //     //     context.drawImage(video, 0, 0, canvas.width, canvas.height);

// //     //     const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// //     //     const code = jsQR(imageData.data, imageData.width, imageData.height);

// //     //     if (code) {
// //     //         stopScanner();
// //     //         initiateVerification(code.data);
// //     //     }
// //     // };

// //     const scanQRCode = () => {
// //         if (!videoRef.current || !canvasRef.current) return;

// //         const video = videoRef.current;
// //         const canvas = canvasRef.current;
// //         const context = canvas.getContext("2d");

// //         if (video.videoWidth === 0 || video.videoHeight === 0) {
// //             console.log("Video not ready yet.");
// //             return;
// //         }

// //         canvas.width = video.videoWidth;
// //         canvas.height = video.videoHeight;
// //         context.drawImage(video, 0, 0, canvas.width, canvas.height);

// //         const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// //         const code = jsQR(imageData.data, imageData.width, imageData.height);

// //         if (code) {
// //             stopScanner();
// //             initiateVerification(code.data);
// //         }
// //     };


// //     const stopScanner = () => {
// //         if (scanIntervalRef.current) {
// //             clearInterval(scanIntervalRef.current);
// //         }
// //         if (streamRef.current) {
// //             streamRef.current.getTracks().forEach(track => track.stop());
// //         }
// //         setShowScanner(false);
// //     };

// //     const initiateVerification = async (qr) => {
// //         setLoading(true);
// //         try {
// //             const response = await axios.post(`${adminUrl}/verify-qr`, { qr_code: qr });
// //             setMessage(response.data.message);
// //             setIsOtpSendModalOpen(true);
// //             setScannedQrCode(qr);
// //         } catch (error) {
// //             setMessage(error.response?.data?.message || "Error initiating verification");
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     const completeVerification = async (otpCode) => {
// //         try {
// //             const response = await axios.post(`${adminUrl}/verify-qr`, {
// //                 qr_code: scannedQrCode,
// //                 otp: otpCode,
// //             });

// //             toast.success(`Verification successful! Withdrawal Amount: ${response.data.gold_grams} grams`);
// //             handleOtpSendModalClose();
// //         } catch (error) {
// //             toast.error(error.response?.data?.message || "Error verifying OTP");
// //         }
// //     };

// //     const handleImageUpload = async (event) => {
// //         const file = event.target.files[0];
// //         if (!file) return;

// //         const reader = new FileReader();
// //         reader.onload = (e) => {
// //             const img = new Image();
// //             img.src = e.target.result;
// //             img.onload = () => {
// //                 const canvas = document.createElement("canvas");
// //                 const context = canvas.getContext("2d");
// //                 canvas.width = img.width;
// //                 canvas.height = img.height;
// //                 context.drawImage(img, 0, 0, img.width, img.height);

// //                 const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// //                 const code = jsQR(imageData.data, imageData.width, imageData.height);

// //                 if (code) {
// //                     initiateVerification(code.data);
// //                     setShowButtons(false);
// //                 } else {
// //                     toast.error("No QR code detected.");
// //                 }
// //             };
// //         };
// //         reader.readAsDataURL(file);
// //     };

// //     return (
// //         <div style={{ padding: "20px", textAlign: "center" }}>
// //             {loading && <FullPageLoader />}
// //             <div className="login-container">
// //                 <Grid container>
// //                     <Grid item xs={12} md={12} sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 4, width: "100%" }}>
// //                         <Box sx={{ width: "100%", maxWidth: 350, py: 8, px: 4, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", boxShadow: "2px", background: "white" }}>
// //                             <Typography variant="h4" textAlign="center" sx={{ fontSize: "30px", fontWeight: "600", mb: 4 }}>
// //                                 Scan QR
// //                             </Typography>

// //                             {showScanner && (
// //                                 <video
// //                                     ref={videoRef}
// //                                     style={{ width: "100%", maxWidth: "400px", height: "auto" }}
// //                                     autoPlay
// //                                     playsInline
// //                                 />
// //                             )}


// //                             {showButtons ? (
// //                                 <>
// //                                     <QrCodeScannerIcon sx={{ fontSize: 80, mb: 2, color: "#C38F51" }} />
// //                                     <Button variant="contained" component="label" sx={{ mt: 2, width: "100%", background: "#C38F51", "&:hover": { backgroundColor: "#3B4056" } }}>
// //                                         <CloudUploadIcon sx={{ mr: 1 }} />
// //                                         Upload QR
// //                                         <input type="file" accept="image/*" hidden onChange={handleImageUpload} />
// //                                     </Button>
// //                                     <Button variant="contained" sx={{ mt: 2, width: "100%", background: "#C38F51", "&:hover": { backgroundColor: "#3B4056" } }} onClick={startScanner}>
// //                                         Start Scanning
// //                                     </Button>
// //                                 </>
// //                             ) : (
// //                                 <>
// //                                     <Typography sx={{ mt: 2, color: "green" }}>{message}</Typography>
// //                                     <Button variant="contained" sx={{ mt: 2, width: "100%", background: "#C38F51", "&:hover": { backgroundColor: "#3B4056" } }} onClick={() => setShowButtons(true)}>
// //                                         Back
// //                                     </Button>
// //                                 </>
// //                             )}
// //                         </Box>
// //                     </Grid>
// //                     <ToastContainer position="top-right" autoClose={1500} hideProgressBar theme="dark" />
// //                 </Grid>
// //             </div>

// //             <OtpsSendModal open={isOtpSendModalOpen} onClose={handleOtpSendModalClose} completeVerification={completeVerification} />
// //         </div>
// //     );
// // };

// // export default WithdrawForScanQR;





import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import jsQR from "jsqr"; // Import jsQR
import { Box, Button, Grid, Typography, Input } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { adminUrl } from "../../../constants";
import OtpsSendModal from "../../../Components/OtpSendModal/OtpsSendModal";
import FullPageLoader from "../../../Components/FullPageLoader/FullPageLoader";
import { useDispatch } from "react-redux";
import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";


const WithdrawForSacnQR = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [showScanner, setShowScanner] = useState(false);
    const [scannedQrCode, setScannedQrCode] = useState("");
    const [isOtpSendModalOpen, setIsOtpSendModalOpen] = useState(false);

    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const streamRef = useRef(null);
    const scanIntervalRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setHeaderName("Master"));
        dispatch(setSubHeaderName("Withdraw Gold"));
    }, []);

    const handleOtpSendModalClose = () => {
        setIsOtpSendModalOpen(false);
    };

    // Function to start the camera and scan for QR codes
    // const startScanner = async () => {
    //     setShowScanner(true)
    //     try {
    //         const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
    //         videoRef.current.srcObject = stream;
    //         streamRef.current = stream;

    //         scanIntervalRef.current = setInterval(() => {
    //             scanQRCode();
    //         }, 500);
    //     } catch (error) {
    //         console.error("Error accessing camera:", error);
    //         setMessage("Camera access denied.");
    //     }
    // };


    const startScanner = async () => {
        setShowScanner(true);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
            videoRef.current.srcObject = stream;
            streamRef.current = stream;

            videoRef.current.onloadedmetadata = () => {
                videoRef.current.play(); // Ensure video starts playing before scanning

                scanIntervalRef.current = setInterval(() => {
                    scanQRCode();
                }, 500);
            };
        } catch (error) {
            console.error("Error accessing camera:", error);
            setMessage("Camera access denied.");
        }
    };

    // Function to scan QR code from video feed
    // const scanQRCode = () => {
    //     if (!videoRef.current || !canvasRef.current) return;

    //     const video = videoRef.current;
    //     const canvas = canvasRef.current;
    //     const context = canvas.getContext("2d");

    //     canvas.width = video.videoWidth;
    //     canvas.height = video.videoHeight;
    //     context.drawImage(video, 0, 0, canvas.width, canvas.height);

    //     const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    //     const code = jsQR(imageData.data, imageData.width, imageData.height);

    //     if (code) {
    //         stopScanner();
    //         initiateVerification(code.data);
    //     }
    // };

    const scanQRCode = () => {
        if (!videoRef.current || !canvasRef.current) return;

        const video = videoRef.current;
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        // Ensure video is ready
        if (video.videoWidth === 0 || video.videoHeight === 0) {
            console.warn("Video not ready yet");
            return;
        }

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);

        if (code) {
            stopScanner();
            initiateVerification(code.data);
        }
    };


    // Function to stop the scanner
    const stopScanner = () => {
        if (scanIntervalRef.current) {
            clearInterval(scanIntervalRef.current);
        }
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
        }
        setShowScanner(false);
    };

    // Function to verify QR code
    const initiateVerification = async (qr) => {
        setLoading(true);
        try {
            const response = await axios.post(`${adminUrl}/verify-qr`, { qr_code: qr });
            setMessage(response.data.message);
            setIsOtpSendModalOpen(true);
            setScannedQrCode(qr);
        } catch (error) {
            setMessage(error.response?.data?.message || "Error initiating verification");
        } finally {
            setLoading(false);
        }
    };

    // Function to handle file upload and process QR code from an image
    // const handleFileUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (!file) return;

    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //         const image = new Image();
    //         image.src = e.target.result;
    //         image.onload = () => {
    //             const canvas = canvasRef.current;
    //             const context = canvas.getContext("2d");

    //             canvas.width = image.width;
    //             canvas.height = image.height;
    //             context.drawImage(image, 0, 0, canvas.width, canvas.height);

    //             const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    //             const code = jsQR(imageData.data, imageData.width, imageData.height);

    //             if (code) {
    //                 initiateVerification(code.data);
    //             } else {
    //                 toast.error("No QR code found in the image.");
    //             }
    //         };
    //     };
    //     reader.readAsDataURL(file);
    // };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const image = new Image();
            image.src = e.target.result;
            image.onload = () => {
                if (!canvasRef.current) {
                    console.error("Canvas element not found.");
                    return;
                }

                const canvas = canvasRef.current;
                const context = canvas.getContext("2d");

                if (!context) {
                    console.error("Unable to get canvas context.");
                    return;
                }

                canvas.width = image.width;
                canvas.height = image.height;
                context.drawImage(image, 0, 0, canvas.width, canvas.height);

                const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);

                if (code) {
                    initiateVerification(code.data);
                } else {
                    toast.error("No QR code found in the image.");
                }
            };
        };
        reader.readAsDataURL(file);
    };


    const completeVerification = async (otpCode) => {
        try {
            const response = await axios.post(`${adminUrl}/verify-qr`, {
                qr_code: scannedQrCode,
                otp: otpCode,
            });

            toast.success(`Verification successful! Withdrawal Amount: ${response.data.gold_grams} grams`);
            setMessage(`Verification successful! Withdrawal Amount: ${response.data.gold_grams} grams`)
            handleOtpSendModalClose();
        } catch (error) {
            toast.error(error.response?.data?.message || "Error verifying OTP");
        }
    };

    return (
        <div style={{ padding:{md:"20px",xs:"0px"}, textAlign: "center" }}>
            {loading && <FullPageLoader />}
            <div className="login-container">
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: {md:4,xs:0},
                            width: "100%",
                        }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                maxWidth: 350,
                                py: 8,
                                px: 4,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "2px",
                                background: "white",
                            }}
                        >
                            <Typography variant="h4" textAlign="center" sx={{ fontSize: "30px", fontWeight: "600", mb: 4 }}>
                                Scan QR
                            </Typography>

                            {/* {showScanner && (
                                <>
                                    <video ref={videoRef} autoPlay style={{ width: "100%", maxWidth: "300px" }}></video>
                                    <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            mt: 2,
                                            textTransform: "none",
                                            color: "white",
                                            fontSize: "16px",
                                            width: "100%",
                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            background: "#C38F51",
                                            "&:hover": { backgroundColor: "#3B4056" },
                                        }}
                                        onClick={startScanner}
                                    >
                                        Start Scanning
                                    </Button>
                                </>
                            )} */}

                            {/* Hidden File Input */}


                            {!message && (
                                <>
                                    {showScanner && (
                                        <>
                                            <video ref={videoRef} autoPlay style={{ width: "100%", maxWidth: "300px" }}></video>
                                            <canvas ref={canvasRef} style={{ display: "none" }}></canvas>

                                            <Button
                                                variant="contained"
                                                sx={{
                                                    mt: 2,
                                                    textTransform: "none",
                                                    color: "white",
                                                    fontSize: "16px",
                                                    width: "100%",
                                                    minHeight: "40px",
                                                    borderRadius: "23px",
                                                    background: "#C38F51",
                                                    "&:hover": { backgroundColor: "#3B4056" },
                                                }}
                                                onClick={stopScanner}
                                            >
                                                Stop Scanning
                                            </Button>
                                        </>
                                    )}
                                    {!showScanner && (
                                        <>
                                            <QrCodeScannerIcon sx={{ fontSize: 80, mb: 2, color: "#C38F51" }} />

                                            <Button
                                                variant="contained"
                                                sx={{
                                                    mt: 2,
                                                    textTransform: "none",
                                                    color: "white",
                                                    fontSize: "16px",
                                                    width: "100%",
                                                    minHeight: "40px",
                                                    borderRadius: "23px",
                                                    background: "#C38F51",
                                                    "&:hover": { backgroundColor: "#3B4056" },
                                                }}
                                                onClick={startScanner}
                                            >
                                                Start Scanning
                                            </Button>
                                        </>
                                    )}

                                    {/* <Input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileUpload}
                                        sx={{ display: "none" }}
                                        id="upload-file"
                                    />

                                    <label htmlFor="upload-file">
                                        <Button
                                            component="span"
                                            variant="contained"
                                            sx={{
                                                mt: 2,
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                width: "100%",
                                                minHeight: "40px",
                                                borderRadius: "23px",
                                                background: "#C38F51",
                                                "&:hover": { backgroundColor: "#3B4056" },
                                            }}
                                        >
                                            Choose File
                                        </Button>
                                    </label> */}
                                </>
                            )}


                            {message && (
                                <>
                                    <Typography sx={{ mt: 2, color: "green" }}>{message}</Typography>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            mt: 2,
                                            textTransform: "none",
                                            color: "white",
                                            fontSize: "16px",
                                            width: "100%",
                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            background: "#C38F51",
                                            "&:hover": { backgroundColor: "#3B4056" },
                                        }}
                                        onClick={() => {
                                            setMessage("");
                                            setShowScanner(false);
                                            // startScanner();
                                        }}
                                    >
                                        Scan Again
                                    </Button>
                                </>
                            )}
                        </Box>
                    </Grid>
                    <ToastContainer position="top-right" autoClose={1500} hideProgressBar theme="dark" />
                </Grid>
            </div>

            <OtpsSendModal open={isOtpSendModalOpen} onClose={handleOtpSendModalClose} completeVerification={completeVerification} />
        </div >
    );
};

export default WithdrawForSacnQR;
